import { render, staticRenderFns } from "./ManteBazar.vue?vue&type=template&id=0549f7ca&"
import script from "./ManteBazar.vue?vue&type=script&lang=js&"
export * from "./ManteBazar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports